import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import {
  DOCUMENT_STATUSES
} from '@xanadu/ui-shared/modules/user/data';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from '../../KycMessaging.module.scss';

const { ADDITIONAL_DOCS } = DOCUMENT_STATUSES;

const EddVerification = ({
  closeModal,
  eddStatus,
  navigate
}) => (
  <Fragment>
    <div>
      <div className={styles.title}>
        Enhanced Due Diligence Check
      </div>
      <div className={styles.bold}>
        {eddStatus === ADDITIONAL_DOCS
          ? 'Unfortunately the documents you provided were insufficient.'
          : 'We are required to request some due diligence documentation from you.'
        }
      </div>
      <div>
        <span>An email has been sent to your registered email outlining what is required.</span>
        <br />
        <br />
        <span>If you have any questions, you can contact us on Live Chat.</span>
      </div>
    </div>
    <div className={styles.containerActions}>
      <Button
        sizeType="wider"
        buttonType="flat"
        onClick={closeModal}
        style={{ marginRight: 16 }}
      >{"I'll do it later"}</Button>
      <Button
        sizeType="wider"
        buttonType="primary"
        onClick={() => {
          closeModal();
          navigate('/page/faqs/know-your-customer-requirements/');
        }}
      >FAQs</Button>
    </div>
  </Fragment>
);

EddVerification.propTypes = {
  closeModal: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  eddStatus: PropTypes.string.isRequired,
};

export default EddVerification;

